<template>
  <div align="center">
    <v-layout row justify-center align="center" mt-5>
      <v-flex xs10 sm8 md6 lg4 mt-5>
        <form class="login" @submit.prevent="login">
          <v-card>
            <div color="primary" class="height-20 justify-center" dark flat>
              <div class="justify-center py-3 black white--text text-uppercase font-weight-bold text-xs-center">Login into CMS</div>
              <div class="flex-grow-1"></div>
            </div>
            <!-- <v-card-title color="primary" dark flat>
              <h3 class="headline">Login to CMS</h3>
            </v-card-title> -->
            <v-card-text>
              <v-container fluid pb-0 mb-0>
                <v-layout row mb-2>
                  <v-flex xs12>
                    <v-text-field flat name="login" label="Username" v-model="username" prepend-inner-icon="person" ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field name="password" label="Password" 
                      prepend-inner-icon="lock"
                      inner-icon-color="black"
                      flat  primary counter
                      v-model="password"
                      :append-icon="e1 ? 'visibility' : 'visibility_off'"
                      :append-icon-cb="() => (e1 = !e1)"
                      :type="e1 ? 'password' : 'text'"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row v-if="error">
                  <div class="pb-2 pt-3 alert alert-danger">{{ error }}</div>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions class="pb-5 pt-0 d-block mx-auto" flexbox>
              <!-- <v-btn flat color="grey" to="http://www.tba21.org">I am looking for public site of TBA</v-btn> -->
              <v-btn type="submit" class="mt-5" color="primary" :disabled="canLogin">Log me in</v-btn>
            </v-card-actions>
            <v-progress-linear height="3" v-if="overlay" indeterminate></v-progress-linear>
          </v-card>
        </form>
      </v-flex>
    </v-layout>
    <!-- <v-overlay :value="overlay"> -->
    <!-- </v-overlay> -->
  </div>
</template>

<script>
  import {AUTH_REQUEST} from '@/store/actions/auth'
  import { mapGetters, mapState } from 'vuex'
  // import { AUTH_LOGOUT } from '@/store/actions/auth'

  export default {
    name: 'login',
    data () {
      return {
        username: '',
        password: '',
        e1: true,
        overlay: false,
        error: false
      }
    },
    methods: {
      login: function () {
        this.error = false
        this.overlay = true
        const { username, password } = this
        this.$store.dispatch(AUTH_REQUEST, { username, password }).then((r) => {
          // console.log(r)
          this.overlay = false
          // this.$router.push('/facts')
          var u = r.user
          // console.log(u)
          if (u.after_login_page) {
            this.$router.push({ path: u.after_login_page })
          } else {
            this.$router.push({ path: '/artworks/ownership/collection' })
          }
        })
        .catch(() => {
          this.overlay = false
          this.error = 'Wrong Login. Please check your credentials and keyboard layout.'
        })
      }
    },
    computed: {
      ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded']),
      ...mapState({
        authLoading: state => state.auth.status === 'loading',
        name: state => `${state.user.profile.title} ${state.user.profile.name}`,
      }),
      canLogin () {
        return !(!!this.username && !!this.password)
      }
    }
  }
</script>

<style>
  /* .login {
    display: flex;
    flex-direction: column;
    width: 500px;
    padding: 10px;
  } */
</style>



// WEBPACK FOOTER //
// src/components/login/index.vue